import { create } from 'zustand';

const AUTH = () => ({ Authorization: `Bearer ${localStorage.getItem('auth_token')}` });

export const useFriendStore = create((set, get) => ({
  friends: [],
  pendingReceived: [],
  pendingSent: [],
  loading: false,

  fetchAll: async () => {
    set({ loading: true });
    try {
      const r = await fetch('/api/friends', { headers: AUTH() });
      const d = await r.json();
      set({ friends: d.friends || [], pendingReceived: d.pendingReceived || [], pendingSent: d.pendingSent || [], loading: false });
    } catch {
      set({ loading: false });
    }
  },

  sendRequest: async (usernameOrId) => {
    const r = await fetch('/api/friends/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...AUTH() },
      body: JSON.stringify({ usernameOrId }),
    });
    const d = await r.json();
    if (d.success) await get().fetchAll();
    return d;
  },

  acceptRequest: async (userId) => {
    await fetch(`/api/friends/accept/${userId}`, { method: 'POST', headers: AUTH() });
    await get().fetchAll();
  },

  declineRequest: async (userId) => {
    await fetch(`/api/friends/decline/${userId}`, { method: 'POST', headers: AUTH() });
    await get().fetchAll();
  },

  removeFriend: async (userId) => {
    await fetch(`/api/friends/${userId}`, { method: 'DELETE', headers: AUTH() });
    await get().fetchAll();
  },
}));
